<template>

    <div class="navbar">

        <div class="navbar-wrapper cf relative">

            <div class="absolute logo">

                <img class="pointer" src="../../assets/images/logo.png" @click="openIndex">

            </div>

            <div class="fr login-type cf">

                <div v-if="!isLogin" class="fl cf">

                    <div class="fl pointer" @click="openLoginPop">登录</div>

                    <div class="fl line-margin"> | </div>

                    <div class="fl pointer" @click="openRegPop">注册</div>

                </div>

                <div v-else class="fl cf">

                    <div class="user-info pointer cf fl" @click="openUserInfo">

                        <img class="fl avatar" :src="userinfo.head_pic || require('../../assets/images/avatar.png')" />

                        <span class="fl">我的</span>

                    </div>

                    <div class="fl line-margin"> | </div>

                    <div class="fl pointer" @click="outLogin">退出</div>

                </div>

                <div class="fl">

<!--                    <div class="fl line-margin"> | </div>-->
<!--                    <div class="fl pointer">微博</div>-->
<!--                    <div class="fl line-margin"> | </div>-->
<!--                    <div class="fl pointer">微信</div>-->

                </div>

            </div>

        </div>

        <div class="tab-wrapper" :class="{'fix-nav': navBarFixed}">
            <div class="tab cf">

                <div class="fl tab-fl cf">

                    <div
                        v-for="(item,index) in tabList"
                        :key="'tab-item-'+index"
                        class="tab-item fl"
                        :class="[v_selected == index ? 'itemColor' : '']"
                        @click="changeTab(item,index)"
                    >{{ item.title }}</div>

                </div>

                <div class="fr search cf">

                    <div class="fl search-icon">
                        <img src="../../assets/images/search.png" />
                    </div>

                    <input
                        class="fl"
                        type="text"
                        placeholder="请输入搜索内容"
                        v-model="keyword"
                        @keyup.enter="onSearch"
                    />

                    <img v-if="keyword" class="clear fr" @click="keyword = ''" src="./images/close.png" />

                </div>

            </div>
        </div>

        <overlay :show="showMask" @close="closeMask">

            <layout-login
                :show="is_login"
                @close="closeMask"
            />

            <layout-reg
                :show="is_reg"
                @close="closeMask"
            />

            <layout-forget
                :show="is_forget"
                @close="closeMask"
            />


        </overlay>

    </div>

</template>

<script>
import Overlay from '../../components/overlay/main'
import mixin from "./mixin/mixin";
import navBarMixin from './mixin/nav-bar-mixix';
import LayoutLogin from '../layout-login/main';
import LayoutReg from '../layout-reg/main';
import LayoutForget from '../layout-forget/main';

export default {
    name: "navbar",
    components: {
        Overlay,
        LayoutLogin,
        LayoutReg,
        LayoutForget
    },
    props: {
        selected: {
            type: Number,
            default: 0
        }
    },
    mixins: [mixin,navBarMixin]
}
</script>

<style scoped src="./style.css"></style>
